import React, { ReactElement } from "react";
import Layout from "../../../components/layout";
import ShopOutOfStockList from "../../../components/Shops/Products/out-of-stock";

const ShopOutOfStockPage = (): ReactElement => {
  return (
    <Layout>
      <ShopOutOfStockList />
    </Layout>
  );
};

export default ShopOutOfStockPage;
